<template>
  <div id="app">
    <introduction v-on:serve="serveSite" v-on:scroll="scrollToItem" />
    <div class="projects" ref="projects">
      <projects v-if="isServed" />
    </div>
  </div>
</template>

<script>
import Introduction from "@/components/Introduction.vue";
import Projects from "@/components/Projects.vue";

export default {
  name: "App",
  components: {
    Introduction,
    Projects
  },
  data() {
    return {
      isServed: false
    };
  },
  methods: {
    serveSite() {
      // npm run serve or skip
      this.isServed = true;
    },
    scrollToItem(location) {
      var options = {
        container: "body",
        easing: "ease",
        force: true,
        cancelable: false,
        x: false,
        y: true
      };

      // console.log("Scrolling to " + location);
      this.$scrollTo(this.$refs[location], 1500, options);
      // console.log(cancelScroll);
    }
  },
  mounted() {}
};
</script>

<style>
html {
  overflow-y: scroll;
}
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  overflow: hidden;
}
</style>
